import BaseModelAPI from '../BaseModelAPI';

export default class DocumentCategoryList extends BaseModelAPI {

	static entity = 'documentcategorylist'
	static entityName = 'documentcategory';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
